import React from "react";
import { Item } from "./Yuyue";
import styles from "../css/Yuyue.css";
import { Header } from "./Introduce";
import { Button, Toast } from "antd-mobile";
import { request } from "../request";
import {
  checkPhone,
  checkEmail,
  checkZE,
  checkNum,
  Loading,
} from "../tools/wechatBrower";
import _ from "lodash";
function getId(name) {
  return document.getElementById(name)
    ? document.getElementById(name).value
    : "";
}

export default class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        info: {},
        default: {},
      },
      loading: true,
    };
  }

  componentDidMount() {
    console.log(this.props.match.params.id);
    request(
      "index/getReceiving",
      {
        uid: localStorage.getItem("openid"),
        receiving_id: this.props.match.params.id,
      },
      ({ data }) => {
        if (data) {
          this.setState({
            data: data.data,
          });
          console.log(data.data.info);
        }
        this.setState({
          loading: false,
        });
      }
    );
  }

  address(e) {
    this.state.data.info.address = e;
    this.setState({
      data: this.state.data,
    });
  }

  tag(e) {
    this.state.data.info.tag = e;
    this.setState({
      data: this.state.data,
    });
  }

  main() {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        {/* <input type="text" defaultValue={"默认值"} placeholder="请输入姓名" /> */}
        <div className={styles.info}>
          <div className={styles.head}>
            <span className={styles.title}>个人信息</span>
          </div>
          <Item
            left="标签"
            rightP="用于识别唯一收件信息"
            id="tag"
            value={this.state.data.info.tag}
            onChange={(e) => {
              this.tag(e);
            }}
          ></Item>
          <Item
            left="姓名"
            rightP="请输入姓名"
            id="name"
            value={this.state.data.info.name}
            onChange={(e) => {
              if (checkZE(e)) {
                this.state.data.info.name = e;
                this.setState();
              }
            }}
            onBlur={(e) => {
              let is_topic_leader = checkZE(this.state.data.info.name);
              if (!is_topic_leader) {
                Toast.fail("姓名只允许中英文,最多二十个字");
                return;
              }
            }}
          ></Item>
          <Item
            left="联系电话"
            rightP="请输入联系电话"
            id="phone"
            value={this.state.data.info.phone}
            onChange={(e) => {
              if (checkNum(e)) {
                this.state.data.info.phone = e;
                this.setState();
              }
            }}
            onBlur={(e) => {
              let is_phone = checkPhone(getId("phone"));
              if (!is_phone) {
                Toast.fail("手机号格式不正确");
                return;
              }
            }}
          ></Item>
          <Item
            left="收件地址"
            rightP="请输入收件地址"
            id="address"
            value={this.state.data.info.address}
            onChange={(e) => {
              this.address(e);
            }}
          ></Item>
        </div>
      </div>
    );
  }

  _sub() {
    {
      console.log("this.state", this.state);
      if (
        !(
          this.state.data.info.name &&
          this.state.data.info.phone &&
          getId("address") &&
          getId("tag")
        )
      ) {
        Toast.fail("必填项不得为空");
        return;
      }

      if (!/^1[3|4|5|7|8]\d{9}$/.test(this.state.data.info.phone)) {
        Toast.fail("手机号码有误，请重填");
        return false;
      }

      let is_topic_leader = checkZE(this.state.data.info.name);
      if (!is_topic_leader) {
        Toast.fail("姓名只允许中英文,最多二十个字");
        return;
      }

      request(
        "index/changeReceiving",
        {
          tag: getId("tag"),
          uid: localStorage.getItem("openid"),
          // uid: "o3KXx5lSukpaX5Lwn_JRTiW5R_hk", // localStorage.getItem("openid"),
          receiving_id: this.props.match.params.id,
          name: this.state.data.info.name,
          phone: this.state.data.info.phone,
          address: getId("address"),
        },
        ({ data }) => {
          console.log(data);

          data.code === 1 ? Toast.info("保存成功") : Toast.fail("保存失败");
          setTimeout(() => {
            this.props.history.push("/receivingInformation/list");
          }, 1000);
        }
      );
    }
  }

  sumbit() {
    return (
      <div
        style={{
          position: "fixed",
          height: "70px",
          left: 0,
          bottom: 0,
          right: 0,
          // backgroundColor: "rgb(51 51 51 / 14%)",
          display: "flex",
          maxWidth: "375px",
          margin: "auto",
        }}
      >
        <Button
          type="primary"
          style={{
            width: "88%",
            backgroundColor: "#AE5CC9",
            borderRadius: "23px",
            border: "1px solid #AE5CC9",
            margin: "auto",
          }}
          onClick={_.throttle(this._sub.bind(this), 500)}
        >
          保存
        </Button>
      </div>
    );
  }

  render() {
    return (
      <div>
        <Header text="收件信息"></Header>
        {this.main()}
        {this.sumbit()}
        <Loading loading={this.state.loading}></Loading>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/ReceivingInformationEdit.js